import useAppStore from "@/context/store";
import { getCurrentUser } from "@/services";
import HBMessage from "../components/HBMessage";
import LoginDialog from "../components/LoginModal";
import PinSuccessMessage from "../components/PinSuccessMessage";
import { openSettingPage } from "./gaoding";
import { isClosedToday } from "./isClosedToday";

export async function checkCanUploadPin(user: IUser) {
  if (!user?.tel) {
    HBMessage.error("根据《互联网用户账号信息管理规定》，上传采集需绑定手机号");
    // Router.push("/settings?tab=account");
    openSettingPage(user, {
      query: "tab=account",
      page: "account",
    });
    return;
  }

  return true;
}

export async function checkLogin(props?: { source_location?: string }) {
  let user = useAppStore.getState().user;

  if (!user) {
    try {
      await LoginDialog.asyncOpen(props || {});
    } catch (error) {
      // 未登录忽略
    }

    user = useAppStore.getState().user;

    if (!user) {
      return;
    }
  }

  return user;
}

export async function openCreatePin({ fileList = null } = {}) {
  const user = await checkLogin({
    source_location: "创建采集",
  });

  if (!user?.user_id) {
    // 用户信息获取失败情况
    return;
  }

  if (!checkCanUploadPin(user)) {
    return;
  }

  if (!user?.tel) {
    await openBindTelModal();
  }

  const { PinUploaderModal } = await import("../components/PinCreator");

  PinUploaderModal.open({
    fileList: fileList,
    name: "pinUploaderModal",
    onOk: (board, list, hasAiImg) => {
      PinSuccessMessage.open({
        pin: { ...board?.pins?.shift(), board },
        extra: hasAiImg
          ? { link: "/ai", subtitle: "AI作品已发布到", title: "AI圈" }
          : null,
        hideButton: true,
      });
    },
  });
}

export async function openBoardModal(props: {
  name?: string;
  boardId?: number;
  collectionId?: number;
  onUpdate?: (board: IBoardInfo) => void;
  onDelete?: () => void;
  onOk?: (board: IBoardInfo) => void;
  onExitBoard?: () => void;
  onRemoveMember?: (user: IUser) => void;
}) {
  const user = await checkLogin({
    source_location: "画板弹窗",
  });

  if (!user?.user_id) {
    return;
  }

  await openBindTelModal();

  const { default: BoardModal } = await import("@/components/BoardModal");

  BoardModal.open(props);
}

export async function openBindTelModal(props?: {
  user?: IUser;
  onOk?: (user?: IUser) => void;
  onCancel?: () => void;
  /**是否强制绑定手机号，关闭不绑定会退出登录 */
  isCompulsory?: boolean;
  /**需要记录是否关闭过，关闭过今天就不在弹出 */
  needCloseRecord?: boolean;
  /**关闭弹窗是否需要继续*/
  cancelNeedResolve?: boolean;
  /**是否显示关闭按钮 */
  closable?: boolean;
}) {
  let user =
    props?.user ||
    (await checkLogin({
      source_location: "绑定手机号",
    }));
  const { closable = true } = props || {};

  if (!user?.user_id || user?.tel) {
    return user;
  }

  // 获取稿定用户信息
  const gdUser = await getCurrentUser();

  // 判断当前账号在稿定是否绑定手机号
  if (gdUser?.mobile) {
    return user;
  }

  // void fn
  let onCancel = props?.onCancel || (() => {});

  if (props?.needCloseRecord) {
    const { hasClosed, onCloseRecord } = isClosedToday("hb_bind_tel_dialog");

    // 记录关闭
    onCancel = () => {
      props.onCancel?.();
      onCloseRecord();
    };

    if (hasClosed) {
      return user;
    }
  }

  const { default: Modal } = await import("@/components/LoginModal/bindTel");

  return new Promise((resolve) => {
    Modal.open({
      user,
      closable,
      maskClosable: closable,
      keyboard: closable,
      isCompulsory: props?.isCompulsory,
      onOk: async (user) => {
        props?.onOk?.(user);
        resolve(user);
      },
      onCancel() {
        onCancel();
        if (props?.cancelNeedResolve) {
          resolve(false);
        }
      },
    });
  });
}

/**
 * 指定宽高，居中打开独立窗口
 * @param option
 * @returns
 */
export function openWindow({ clientHeight, clientWidth, url, windowName }) {
  const top = (window.innerHeight - clientHeight) / 2 + window.screenTop;
  const left = (window.innerWidth - clientWidth) / 2 + window.screenLeft;

  return window.open(
    url,
    windowName,
    `width=${clientWidth},height=${clientHeight}, top=${top}, left=${left}`
  );
}
